import React from 'react';
import {
    Link, Redirect, Route, Switch, useLocation,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GlobalBackButtonProvider } from './GlobalBackButtonContext';
import { ModalProvider } from './ModalContext';
import { WidgetHeader } from './components/WidgetHeader/WidgetHeader';
import { FiltersSection } from './features/filters/Filters';
import { Doctors } from './features/doctors/Doctors';
import { BookingForm } from './features/bookingForm/BookingForm';
import { SuccessBooking } from './pages/SuccessBooking';
import { Documents } from './pages/Documents';
import aibolitLogo from './assets/images/aibolit.svg';
import { Warning } from './components/Warning/Warning';
import { Version } from './components/Version/Version';
import { bookingFormFields } from './features/bookingForm/utils';

import './widget.scss';
import { useWidgetProps } from './WidgetPropsContext';
import { ServiceBooking } from './serviceBooking/ServiceBooking';
import { getServiceBookingError } from './serviceBooking/store/selectors';
import { WEB_APP_URL } from './clinicsData';

const widget = require('b_')
    .with('widget');

export const App = () => {
    const location = useLocation();
    const {
        state: {
            patientData = {},
            errorMessage,
            isTimeslotOccupied,
        } = {},
    } = location;
    const {
        serviceBooking,
        baseUrl,
        consentsEnabled,
    } = useWidgetProps();
    const serviceError = useSelector(getServiceBookingError);

    const getHeaderTitle = () => {
        if (location.pathname === '/documents' && consentsEnabled === true) {
            return 'Документы';
        }
        return 'online запись';
    };

    return (!!baseUrl &&
        <GlobalBackButtonProvider>
            <ModalProvider>
                <WidgetHeader title={getHeaderTitle()} />
                <div className={widget()}>

                    <Switch>
                        <Route path={'/successfully-booked'}>
                            <SuccessBooking/>
                        </Route>
                        <Route path={'/documents'}>
                            {consentsEnabled === true ? <Documents/> : <Redirect to="/"/>}
                        </Route>
                        <Route exact path="/">
                            {
                                serviceBooking ? (<>
                                    <ServiceBooking/>
                                    <Warning text={serviceError} show={!!serviceError}/>
                                </>) : (
                                    <>
                                        <FiltersSection/>
                                        <Doctors/>
                                    </>
                                )
                            }
                        </Route>
                        <Route path="/error">
                            {
                                serviceBooking ? (
                                    <>
                                        <ServiceBooking patientData={patientData}/>
                                        <Warning text={serviceError} show={!!serviceError}/>
                                    </>

                                ) : (
                                    <>
                                        <FiltersSection isTimeslotOccupied={isTimeslotOccupied} error={errorMessage}/>
                                        <Doctors/>
                                        {!!errorMessage && <Warning text={errorMessage} show/>}
                                    </>
                                )
                            }
                        </Route>
                        <Route path="/timeslot/:timeslotId">
                            {
                                serviceBooking ? (
                                    <>
                                        <ServiceBooking/>
                                    </>
                                ) : (
                                    <>
                                        <FiltersSection/>
                                        <Doctors/>
                                        <BookingForm formName="bookingForm" fields={bookingFormFields} initData={patientData}/>
                                    </>
                                )
                            }
                        </Route>
                    </Switch>
                    <div className={widget('footer')}>
                        <figure className={widget('logo-wrapper')}>
                            <a target="_blank" href={WEB_APP_URL}><img src={aibolitLogo} alt=""
                                className={widget('logo', { aibolit: true })}/></a>
                        </figure>
                        {consentsEnabled === true && location.pathname !== '/documents' && (
                            <Link
                                to="/documents"
                                className={widget('documents-link')}>
                                Документы &gt;
                            </Link>
                        )}
                    </div>
                    <Version/>
                </div>
            </ModalProvider>
        </GlobalBackButtonProvider>
    );
};
